import CredenciadoService from '@/services/credenciado.service'

export default {
  namespaced: true,
  state: {
    credenciado: null,
    credenciados: [],
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setCredenciado: (state, credenciado) => state.credenciado = credenciado,
    setCredenciados: (state, credenciados) => state.credenciados = credenciados,
  },
  actions: {
    selectedCredenciado({ commit }, credenciado) {
      commit('setCredenciado', credenciado)
    },
    async ['buscaCredenciado']({ commit}, { uf, id, search }) {
      try {
        const data = await CredenciadoService.busca(uf, id, search)
        commit('setCredenciados', data)
      } catch (error) {
        commit('setError', errr)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getCredenciado: state => state.credenciado,
    getCredenciados: state => state.credenciados,
  }
}
